import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  UserHierarchyArrayModel,
  UserHierarchyModel,
} from "../../models/UserHierarchyModel";

const initialState: UserHierarchyArrayModel = {
  all_user_hierarchys: [],
  isUserHierarchiesFetching: false,
  all_sbus_uder_sbgs: []
};
const UserHierarchySlice = createSlice({
  name: "UserHierarchy",
  initialState: initialState,
  reducers: {
    setUserHierarchy(state, action: PayloadAction<UserHierarchyModel[]>) {
      state.all_user_hierarchys = action.payload;
    },
    setIsUserHierarchiesFetching(state, action: PayloadAction<boolean>) {
      state.isUserHierarchiesFetching = action.payload;
    },
    setAllSbusUnderSbg(state, action: PayloadAction<any>) {
      state.all_sbus_uder_sbgs = action.payload
    }
  },
});
export default UserHierarchySlice;
